import { render, staticRenderFns } from "./K12.vue?vue&type=template&id=c6886e22"
import script from "./K12.vue?vue&type=script&lang=ts"
export * from "./K12.vue?vue&type=script&lang=ts"
import style0 from "./K12.vue?vue&type=style&index=0&id=c6886e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports